import { defineNuxtRouteMiddleware, useNuxtApp } from '#imports';

export default defineNuxtRouteMiddleware((to, from) => {
    const excludedRoutes = ['participant', 'redirector'];
    if(!excludedRoutes.some(page => page === to.name)){
        const nuxtApp = useNuxtApp();
        const store = nuxtApp.$vuex;
        try {
            store.commit('webGeneral/SET_SIDEBAR_MOBILE_TOGGLE', false);
        } catch (e) {
            console.error('[role-redirect] error resetting sidebar toggle', e);
        }
    }
});